import has from 'lodash/has';

class AppConfig {
  constructor() {
    this.config = {};
  }

  get(configName) {
    if (has(this.config, configName)) {
      return this.config[configName];
    }
    return undefined;
  }

  merge(configObject) {
    this.config = Object.assign(this.config, configObject);
  }
}

export default new AppConfig();
